export const loanProductIDs = {
	149171: 'Debt Consolidation Loan',
	149170: 'Easy Remittance Advance Loan',
	149169: 'Easy Salary Advance Loan',
	149168: 'Easy Top Up Loan',
	145042: 'Personal Loan',
};

export const loanRepaymentMethods = {
	140951: 'Cash',
	140952: 'ATM',
	140953: 'Cheque',
	140954: 'Paypal',
	140955: 'Online Transfer',
	158295: 'System Generated',
	164437: 'Cash Deposit',
	179697: 'Standing Order',
	207002: 'Reve - Digital Wallet Deduction'
};

export const loanPaymentSchemeIds = {
	2184: '14 days',
	2185: '25 days',
	6: 'Daily',
	4: 'Weekly',
	9: 'Biweekly',
	3: 'Monthly',
	12: 'Bimonthly',
	13: 'Quaterly',
	781: 'Every 4 Months',
	14: 'Semi-Annual',
	1943: 'Every 9 Months',
	11: 'Yearly',
	10: 'Lump-Sum'
};

export const loanStatusIDs = {
	1: 'Open',
	2: 'Fully Paid',
	3: 'Defaulted',
	8: 'Processing',
	9: 'Denied',
	17: 'Not Taken Up',
	225966: 'In Progress',
	225967: 'For Review & Approval',
	225968: 'Approved',
	225969: 'For Verification & Disbursement',
	223606: 'Credit Counseling',
	223607: 'Collection Agency',
	223608: 'Sequestrate',
	223609: 'Debt Review',
	223610: 'Fraud',
	223611: 'Investigation',
	223612: 'Legal',
	223613: 'Write-Off'
};

export function roundInterestRate(interestRate, roundingType) {
	switch (roundingType) {
	  case "round_off_to_two_decimal":
		return parseFloat(interestRate).toFixed(2);
	  case "round_off_to_integer":
		return Math.round(interestRate);
	  case "round_down_to_integer":
		return Math.floor(interestRate);
	  case "round_off_to_one_decimal":
		return parseFloat(interestRate).toFixed(1);
	  case "round_up_to_one_decimal":
		return Math.ceil(interestRate * 10) / 10;
	  case "round_up_to_five":
		return Math.ceil(interestRate / 5) * 5;
	  case "round_up_to_ten":
		return Math.ceil(interestRate / 10) * 10;
	  case "round_off_to_hundred":
		return Math.round(interestRate / 100) * 100;
	  default:
		return interestRate; 
	}
  }
  